import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from "zudoku/hooks";
import { useTenantStore } from "../stores/tenantStore";

export default function useDeleteAppRegistration() {
  const apiAccessUrl = import.meta.env.ZUDOKU_PUBLIC_APIACCESSMANAGEMENT_FA_URL
  const subscriptionKey = import.meta.env.ZUDOKU_PUBLIC_SUBSCRIPTION_KEY

  const {providerData} = useAuth()
  const token = providerData?.accessToken || providerData?.idToken;
  const tenantCode = useTenantStore((state) => state.currentTenant);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (applicationId) => {
      const options = {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Authorization": `Bearer ${token}`,
          "X-NBLY-Tenant-Code": tenantCode,
          "X-NBLY-Portal-Type": 'participant',
          "Ocp-Apim-Subscription-Key": subscriptionKey,
      },
      };
      const url = `${apiAccessUrl}/${tenantCode}/applications/${applicationId}`;

      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error('Failed to delete app registration');
      }

      return null;
    },
    onSettled: () => {
      // Invalidate the query to refresh the appRegistrations after deletion
      queryClient.invalidateQueries([
        'GET',
        `${apiAccessUrl}/${tenantCode}/applications`,
      ]);
    },
  });
}
